export interface IReviewStat {
  reviewCountText: string;
  totalRate: number;
  reviewCount: number;
}

export interface IComment {
  /** Текст старого отзыва **/
  legacy?: string;
  /** Минусы **/
  negative?: string;
  /** Плюсы **/
  positive?: string;
  /** Текстовая репрезентация ReviewUserStatus **/
  type: string;
}

export interface ILike {
  /** Кол. дизлайков **/
  dislikesCount: number;
  /** Кол. лайков **/
  likesCount: number;
  /** Наличие лайка/дизлайка от текущего пользователя **/
  status: EStatus;
}
export enum EStatus {
  /** Поставлен дизлайк **/
  'Disliked' = 'disliked',
  /** Поставлен лайк **/
  'Liked' = 'liked',
  /** Нету реакции **/
  'Unknown' = 'unknown',
}

export interface IUser {
  /** URL аватара пользователя **/
  avatarUrl: string;
  /** Имя пользователя **/
  name: string;
}

export interface IReview {
  /** Количество ответов **/
  answersCount: string;
  /** Текст отзыва **/
  comment: IComment;
  /** Дата создания отзыва **/
  date: string;
  /** ID отзыва **/
  id: string;
  /** Анонимный ли отзыв **/
  isAnonymous: boolean;
  /** Скрыт ли отзыв для данного пользователя **/
  isHidden: boolean;
  /** Старый тип отзывов (без плюсов и минусов) **/
  isLegacy: boolean;
  /** лейбл Полезный отзыв **/
  isUseful: boolean;
  /** Данные по лайкам/дизлайкам **/
  like: ILike;
  /** ID ЖК **/
  newbuildingId: number;
  /** Название ЖК **/
  newbuildingName: string;
  /** Ссылка на ЖК **/
  newbuildingUrl: string;
  /** Общая оценка **/
  rating: number;
  /** Ссылка на все отзывы **/
  reviewsUrl: string;
  /** Ссылка на отзыв **/
  url: string;
  /** Данные о пользователе **/
  user: IUser;
}
